var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-overlay',{ref:"overs",attrs:{"show":_vm.showShare,"z-index":"100000"},on:{"click":function($event){_vm.showShare = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }